import { render } from "./WorkspaceClosureDialog.vue?vue&type=template&id=2441297a&ts=true"
import script from "./WorkspaceClosureDialog.vue?vue&type=script&lang=ts"
export * from "./WorkspaceClosureDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__